import { store } from '../store'
import waitForAuthReady from './wait-for-auth'

// Guards the bird weight screen. Besides requiring authentication, it ensures
// the user has the bird weight feature enabled on at least one device (premium
// plans). Users without it are redirected to the dashboard,
// so a direct/deep link to /bird-weight cannot bypass the feature gate.
export default async (to, from, next) => {
  // Wait for Firebase to restore the persisted session before deciding, so a
  // hard refresh on this deep link doesn't redirect an authenticated user.
  await waitForAuthReady()

  if (!store.getters.user) {
    next({ path: '/signin', query: { redirect: to.fullPath } })
    return
  }

  // Device features are loaded on sign-in, but a deep link may resolve before
  // that request settles; make sure we have an answer before deciding.
  if (store.getters.loadedDeviceFeaturesV2.length === 0) {
    await store.dispatch('loadDeviceFeaturesV2')
  }

  if (store.getters.hasBirdWeightFeature) {
    next()
  } else {
    next('/dashboard')
  }
}



// WEBPACK FOOTER //
// ./src/router/bird-weight-guard.js